import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import appReducer from './app';
import userReducer from './user';
import pointReducer from './point';
import experienceReducer from './experience';
import placeReducer from './place';
import storyReducer from './story';

const rootReducer = (history: History) =>
  combineReducers({
    app: appReducer,
    user: userReducer,
    point: pointReducer,
    experience: experienceReducer,
    place: placeReducer,
    story: storyReducer,
    router: connectRouter(history),
  });

export default rootReducer;
